import {
  Radar, RadarChart, PolarGrid, PolarAngleAxis, PolarRadiusAxis, ResponsiveContainer,
} from "recharts";

const RiasecRadar = ({ holland }) => {
  const data = holland.scores.map((s) => ({ subject: s.label, value: s.percent }));
  return (
    <div className="w-full h-72" data-testid="riasec-radar">
      <ResponsiveContainer width="100%" height="100%">
        <RadarChart data={data} outerRadius="78%">
          <PolarGrid stroke="#e2e8f0" />
          <PolarAngleAxis dataKey="subject" tick={{ fill: "#475569", fontSize: 12, fontFamily: "Figtree" }} />
          <PolarRadiusAxis domain={[0, 100]} tick={false} axisLine={false} />
          <Radar dataKey="value" stroke="#4338CA" fill="#4338CA" fillOpacity={0.35} strokeWidth={2} />
        </RadarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default RiasecRadar;
